import React from 'react'
import { CSpinner } from '@coreui/react'
import { useModules } from '../contexts/ModuleContext'

const LoadingHandler = ({ children }) => {
  const { loading, error, fetchModules } = useModules()

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
        <div className="text-danger mb-3">{error}</div>
        <button className="btn btn-primary" onClick={() => fetchModules()}>
          Réessayer
        </button>
      </div>
    )
  }

  return children
}

export default LoadingHandler
